if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        if (this.variantIdInput) this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");
        this.originalButtonHtml = this.submitButtonText
          ? this.submitButtonText.innerHTML
          : null;

        this.initBuyNowIntercept();

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      initBuyNowIntercept() {
        this.form.addEventListener(
          "click",
          (evt) => {
            const buyNowBtn = evt.target.closest(
              ".shopify-payment-button__button",
            );
            if (!buyNowBtn) return;

            const bundleContainer = this.querySelector(
              "[data-flower-bundle-inputs]",
            );
            if (!bundleContainer || bundleContainer.children.length === 0)
              return;

            // If we have a bundle, we need to add to cart via AJAX first
            evt.preventDefault();
            evt.stopPropagation();

            this.handleBuyNowWithBundle();
          },
          true,
        );
      }

      async handleBuyNowWithBundle() {
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");

        const formData = new FormData(this.form);
        const data = this.getFormDataAsJson(formData);

        const config = fetchConfig("json");
        config.headers["X-Requested-With"] = "XMLHttpRequest";

        config.body = JSON.stringify(data);

        try {
          const response = await fetch(`${routes.cart_add_url}`, config);
          const result = await response.json();

          if (!response.ok) {
            const errorMessage =
              result.description ||
              result.message ||
              (result.errors
                ? (typeof result.errors === 'string' ? result.errors : Object.values(result.errors).flat().join(". "))
                : "");
            this.handleErrorMessage(errorMessage);
            this.submitButton.setAttribute("aria-disabled", false);
            this.submitButton.classList.remove("loading");
            if (this.querySelector(".loading-overlay__spinner"))
              this.querySelector(".loading-overlay__spinner").classList.add(
                "hidden",
              );
            return;
          }

          if (data.items && !this.validateBundleLimit(data)) {
            return;
          }

          // Redirect to checkout
          window.location = window.routes.cart_checkout_url;
        } catch (e) {
          console.error(e);
        } finally {
          this.submitButton.removeAttribute("aria-disabled");
          this.submitButton.classList.remove("loading");
        }
      }

      getFormDataAsJson(formData) {
        const data = { items: [] };
        const itemMap = {};
        const mainProduct = { properties: {} };
        let hasBundleItems = false;

        for (const [key, value] of formData.entries()) {
          if (
            [
              "sections",
              "sections_url",
              "form_type",
              "utf8",
              "authenticity_token",
            ].includes(key)
          )
            continue;

          // Detect bundle item fields: items[n][id], items[n][quantity], items[n][properties][name]
          const itemMatch = key.match(
            /^items\[(\d+)\]\[([^\]]+)\](?:\[([^\]]+)\])?$/,
          );
          if (itemMatch) {
            hasBundleItems = true;
            const index = itemMatch[1];
            const itemKey = itemMatch[2];
            const subKey = itemMatch[3]; // e.g. '_bundle_id' from items[0][properties][_bundle_id]

            if (!itemMap[index]) itemMap[index] = { properties: {} };

            if (itemKey === "properties" && subKey) {
              itemMap[index].properties[subKey] = value;
            } else {
              itemMap[index][itemKey] = value;
            }
          } else if (key === "id") {
            mainProduct.id = value;
          } else if (key === "quantity") {
            mainProduct.quantity = value;
          } else if (key.startsWith("properties[")) {
            const propKey = key.match(/properties\[(.+)\]/)[1];
            mainProduct.properties[propKey] = value;
          } else {
            data[key] = value;
          }
        }

        // Aggregate into items array
        if (hasBundleItems) {
          Object.keys(itemMap)
            .sort((a, b) => parseInt(a) - parseInt(b))
            .forEach((index) => {
              if (itemMap[index].id) {
                itemMap[index].id = parseInt(itemMap[index].id, 10);
                itemMap[index].quantity = parseInt(
                  itemMap[index].quantity || "1",
                  10,
                );

                if (
                  itemMap[index].properties &&
                  Object.keys(itemMap[index].properties).length === 0
                ) {
                  delete itemMap[index].properties;
                }

                const existingItem = data.items.find(
                  (item) =>
                    item.id === itemMap[index].id &&
                    JSON.stringify(item.properties || {}) ===
                      JSON.stringify(itemMap[index].properties || {}),
                );

                if (existingItem) {
                  existingItem.quantity += itemMap[index].quantity;
                } else {
                  data.items.push(itemMap[index]);
                }
              }
            });

          if (mainProduct.id) {
            if (
              mainProduct.properties &&
              Object.keys(mainProduct.properties).length === 0
            ) {
              delete mainProduct.properties;
            }
            mainProduct.id = parseInt(mainProduct.id, 10);
            mainProduct.quantity = parseInt(mainProduct.quantity || "1", 10);

            const existingMain = data.items.find(
              (item) =>
                item.id === mainProduct.id &&
                JSON.stringify(item.properties || {}) ===
                  JSON.stringify(mainProduct.properties || {}),
            );

            if (existingMain) {
              existingMain.quantity += mainProduct.quantity;
            } else {
              data.items.unshift(mainProduct);
            }
          }
        } else if (mainProduct.id) {
          if (
            mainProduct.properties &&
            Object.keys(mainProduct.properties).length === 0
          ) {
            delete mainProduct.properties;
          }
          mainProduct.id = parseInt(mainProduct.id, 10);
          mainProduct.quantity = parseInt(mainProduct.quantity || "1", 10);
          data.items.push(mainProduct);
        }

        // Add sections to render
        const sections = this.getSectionsToRender?.() || [];
        if (sections.length > 0) {
          data.sections = sections.map((section) => section.id).join(",");
        }

        return data;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const formData = new FormData(this.form);
        const hasBundleItems = formData.has("items[0][id]");

        let config;
        if (hasBundleItems) {
          // Bundle mode: use JSON to send multiple items
          config = fetchConfig("json");
          config.headers["X-Requested-With"] = "XMLHttpRequest";
          const data = this.getFormDataAsJson(formData);

          if (!this.validateBundleLimit(data)) {
            this.submitButton.classList.remove("loading");
            this.querySelector(".loading__spinner").classList.add("hidden");
            this.submitButton.removeAttribute("aria-disabled");
            return;
          }

          if (this.cart) {
            data.sections = this.cart
              .getSectionsToRender()
              .map((section) => section.id)
              .join(",");
            data.sections_url = window.location.pathname;
          }
          config.body = JSON.stringify(data);
        } else {
          // Standard mode: use original Dawn FormData approach
          config = fetchConfig("javascript");
          config.headers["X-Requested-With"] = "XMLHttpRequest";
          delete config.headers["Content-Type"];
          if (this.cart) {
            formData.append(
              "sections",
              this.cart.getSectionsToRender().map((section) => section.id),
            );
            formData.append("sections_url", window.location.pathname);
          }
          config.body = formData;
        }

        if (this.cart) {
          this.cart.setActiveElement(document.activeElement);
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => {
            return response.json().then((json) => ({
              ok: response.ok,
              status: response.status,
              body: json,
            }));
          })
          .then((response) => {
            if (!response.ok) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId:
                  formData.get("id") || formData.get("items[0][id]"),
                errors: response.body.errors || response.body.description,
                message: response.body.message,
              });

              const errorMessage =
                response.body.description ||
                response.body.message ||
                (response.body.errors
                  ? (typeof response.body.errors === 'string' ? response.body.errors : Object.values(response.body.errors).flat().join(". "))
                  : "");

              this.handleErrorMessage(errorMessage);

              const errorClickEvent = new CustomEvent("cart-error", {
                detail: {
                  source: "product-form",
                  productVariantId:
                    formData.get("id") || formData.get("items[0][id]"),
                  errors: response.body.errors || response.body.description,
                  message: response.body.message,
                },
              });
              this.dispatchEvent(errorClickEvent);

              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker(
              "add:wait-for-subscribers",
            );
            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId:
                  formData.get("id") || formData.get("items[0][id]"),
                cart: response.body,
              }).then(() => {
                CartPerformance.measureFromMarker(
                  "add:wait-for-subscribers",
                  startMarker,
                );
              });

              // Explicitly trigger reset on flower modal if it exists
              const flowerModal = document.querySelector("flower-modal");
              if (
                flowerModal &&
                typeof flowerModal.resetSelections === "function"
              ) {
                flowerModal.resetSelections();
              }
            }
            this.error = false;

            const carts = document.querySelectorAll(
              "cart-notification, cart-drawer",
            );
            const quickAddModal = this.closest("quick-add-modal");

            carts.forEach((cart) => {
              if (quickAddModal) {
                document.body.addEventListener(
                  "modalClosed",
                  () => {
                    setTimeout(() => {
                      CartPerformance.measure(
                        "add:paint-updated-sections",
                        () => {
                          if (response.ok) {
                            carts.forEach((cart) => {
                              if (cart.tagName === "CART-NOTIFICATION") {
                                cart.renderContents(response.body);
                              } else if (cart.tagName === "CART-DRAWER") {
                                // Wait for the cart drawer to be ready
                                if (cart.renderContents) {
                                  cart.renderContents(response.body);
                                }
                              }
                            });
                          }
                        },
                      );
                    });
                  },
                  { once: true },
                );
                quickAddModal.hide(true);
              } else {
                CartPerformance.measure("add:paint-updated-sections", () => {
                  if (response.ok) {
                    carts.forEach((cart) => {
                      if (cart.tagName === "CART-NOTIFICATION") {
                        cart.renderContents(response.body);
                      } else if (cart.tagName === "CART-DRAWER") {
                        // Wait for the cart drawer to be ready
                        if (cart.renderContents) {
                          cart.renderContents(response.body);
                        }
                      }
                    });
                  }
                });
              }
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            const carts = document.querySelectorAll(
              "cart-notification, cart-drawer",
            );
            carts.forEach((cart) => {
              if (cart.classList.contains("is-empty"))
                cart.classList.remove("is-empty");
            });
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        if (this.errorTimer) clearTimeout(this.errorTimer);
        this.errorMessageWrapper.classList.remove("is-fading");

        if (!errorMessage) {
          this.errorMessageWrapper.setAttribute("hidden", "");
          return;
        }

        this.errorMessage.textContent = errorMessage;
        this.errorMessageWrapper.removeAttribute("hidden");

        this.errorTimer = setTimeout(() => {
          this.errorMessageWrapper.classList.add("is-fading");
          setTimeout(() => {
            this.errorMessageWrapper.setAttribute("hidden", "");
            this.errorMessageWrapper.classList.remove("is-fading");
          }, 300); // Matches CSS transition duration
        }, 4000);
      }

      validateBundleLimit(data) {
        if (!data.items || data.items.length < 2) return true;

        const mainProduct = data.items[0];
        const flowers = data.items.slice(1);
        const totalFlowers = flowers.reduce(
          (acc, item) => acc + item.quantity,
          0,
        );
        const limit = mainProduct.quantity * 10;

        if (totalFlowers > limit) {
          const message = `You can only select up to ${limit} extra items for ${mainProduct.quantity} ${mainProduct.quantity === 1 ? "bouquet" : "bouquets"}.`;
          this.handleErrorMessage(message);
          return false;
        }
        return true;
      }

      toggleSubmitButton(disable = true, text, html) {
        const flowerButton = this.querySelector(".button--add-flowers");
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (flowerButton) flowerButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          if (flowerButton) flowerButton.removeAttribute("disabled");

          if (this.flowerData && Object.keys(this.flowerData).length > 0) {
            const flowers = Object.entries(this.flowerData)
              .map(([name, count]) => `${count}x ${name}`)
              .join(" + ");
            const addToCartText =
              window.variantStrings?.addToCart || "Add to cart";
            this.submitButtonText.textContent = `${addToCartText} + ${flowers}`;
            this.submitButton.classList.add("button--merged-add-to-cart");
          } else if (html) {
            this.submitButtonText.innerHTML = html;
          } else {
            this.submitButtonText.innerHTML =
              this.originalButtonHtml || window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        return (
          this.form.querySelector("[name=id]") ||
          this.form.querySelector('[name="items[0][id]"]')
        );
      }
    },
  );
}
